import React, { useState } from 'react';
import { auth, db } from '../firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { doc, setDoc } from 'firebase/firestore'; // Import Firestore functions

const Register = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleRegister = async (e) => {
        e.preventDefault();
        console.log('Register button clicked');
        if (password !== confirmPassword) {
            alert("Passwords do not match");
            return;
        }
        try {
            console.log('Creating user with email:', email);
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;
            console.log('User created:', user);

            // Add user information to Firestore
            await setDoc(doc(db, "users", user.uid), {
                email: user.email,
                uid: user.uid,
                createdAt: new Date(),
                role: "member" // Add role field
            });
            console.log('User information added to Firestore');

            navigate('/');
        } catch (error) {
            console.error('Error registering:', error);
            if (error.code === 'auth/email-already-in-use') {
                setError('The email address is already in use by another account.');
            } else {
                setError('Failed to register. Please try again.');
            }
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen">
            <form onSubmit={handleRegister} className="bg-gradient-to-r from-green-400 to-teal-400 p-6 rounded shadow-md w-full max-w-sm">
                <h2 className="text-white font-bold text-2xl mb-4">Register</h2>
                {error && <p className="text-red-500 mb-4">{error}</p>}
                <div className="mb-4">
                    <label className="block text-white font-light">Email</label>
                    <input 
                        type="email" 
                        value={email} 
                        onChange={(e) => setEmail(e.target.value)} 
                        className="text-black w-full p-2 border border-gray-300 rounded mt-1"
                        required 
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white font-light">Password</label>
                    <input 
                        type="password" 
                        value={password} 
                        onChange={(e) => setPassword(e.target.value)} 
                        className="text-black w-full p-2 border border-gray-300 rounded mt-1"
                        required 
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white font-light">Confirm Password</label>
                    <input 
                        type="password" 
                        value={confirmPassword} 
                        onChange={(e) => setConfirmPassword(e.target.value)} 
                        className="text-black w-full p-2 border border-gray-300 rounded mt-1"
                        required 
                    />
                </div>
                <button type="submit" className="w-full bg-teal-500 text-white p-2 rounded mb-4">Register</button>
            </form>
        </div>
    );
};

export default Register;